import { useEffect, useState } from "react";
import ProductStorageHandler from "../../persistence/ProductStorageHandle";

const MANUFACTURER_LOGO_FETCH_MODE = "backend" as "backend" | "localfetch";

const ManufacturerLogo = ({ name, etsCatalogMode, imgURL }: any) => {
  const formattedName = name.replace("::", " ");
  const logoPath = `${state.hostBaseUrl}images/manufacturer/${formattedName}.png`;
  const useLocalManufacturerLogo = MANUFACTURER_LOGO_FETCH_MODE === "localfetch" && !etsCatalogMode;
  const [imageSrc, setImageSrc] = useState("");
  useEffect(() => {
    let isMounted = true;
    let objectUrl: string | undefined;
    const fetchImage = async () => {
      try {
        // Manufacturer logos are stored by manufacturer name in the image store.
        // Use the direct image-store endpoint, not the product/variant image endpoint.
        const imageBlob = await ProductStorageHandler.downloadImageBlob(formattedName);
        if (imageBlob === undefined) return;

        const nextObjectUrl = URL.createObjectURL(imageBlob);
        if (isMounted) {
          objectUrl = nextObjectUrl;
          setImageSrc(nextObjectUrl);
        } else {
          URL.revokeObjectURL(nextObjectUrl);
        }
      } catch (error) {
        console.error("Error fetching image:", error);
      }
    };

    setImageSrc("");
    if (imgURL) {
      setImageSrc(imgURL);
    } else if (useLocalManufacturerLogo) {
      setImageSrc("");
    } else if (name != "") {
      fetchImage();
    }

    return () => {
      isMounted = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [formattedName, imgURL, name, useLocalManufacturerLogo]);

  const ImageWithFallback = ({ src, alt, style }: any) => {
    const [isError, setIsError] = useState(false);
    const handleError = () => {
      setIsError(true);
    };
    return <>{isError ? <span>{alt}</span> : <img src={src} alt={alt} style={style} onError={handleError} />}</>;
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "68px" }} title={name}>
      {imageSrc && (
        <img src={imageSrc} alt={name} style={{ maxHeight: "50px", maxWidth: "100px", mixBlendMode: "multiply" }} />
      )}
      {!imageSrc && !etsCatalogMode && (
        <ImageWithFallback src={logoPath} alt={name} style={{ maxHeight: "50px", maxWidth: "100px" }} />
      )}
      {!imageSrc && etsCatalogMode && <span>{name}</span>}
      {/* {imageSrc ? <img src={imageSrc} style={{ maxHeight: "68px", maxWidth: "100px" }} /> : <span>{name}</span>} */}
      {/* {<ImageWithFallback src={logoPath} alt={name} style={{ maxHeight: "68px", maxWidth: "100px" }} />} */}
    </div>
  );
};

export default ManufacturerLogo;
